<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newGallery()"
                aria-label="New gallery">
            {{'New'|translate}}
        </button>
    </div>


    <div class="nav material2">
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/cms'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">arrow_back</mat-icon>
                <span>{{'Back'|translate}}</span>
            </a>
        </div>
    </div>
    <div class="nav material2">
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/cms/galleries'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">image</mat-icon>
                <span>{{'Galleries'|translate}}</span>
            </a>
        </div>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
